module.exports = "https://static.zego.com/_next/static/images/Choice-bdc94e6aed82e0dce159d72e64bc7fe7.svg";